import axios from './axios.config';

export interface Log {
    id: number;
    userId: number;
    module: string;
    action: string;
    description: string;
    metadata: Record<string, any>;
    entityId: number;
    entityType: string;
    createdAt: string;
}

export interface LogsResponse {
    logs: Log[];
    total: number;
    page: number;
    limit: number;
}

export interface LogsQueryParams {
    page?: number;
    limit?: number;
    module?: string;
    action?: string;
    startDate?: string;
    endDate?: string;
}

export const logService = {
    getLogs: async (params: LogsQueryParams = {}): Promise<LogsResponse> => {
        try {
            const response = await axios.get<LogsResponse>('/logs', { params });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}; 